import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { intlMessage } from 'constants/propTypes';
import { bem } from 'helpers/class-name';
import { DropdownToggle, DropdownMenu, DropdownItem } from 'components/Dropdown2';

import Dropdown from '../Dropdown/Dropdown';
import messages from '../messages';
import { getTimes } from './TimePicker.helpers';

const filterTime = (filter, label) => {
  const transformRawString = str => {
    const scrubbed = str.replace(/:|\s/gi, '');
    return [scrubbed.replace(/\D/gi, '').replace(/^0/g, ''), scrubbed.replace(/\d/gi, '').toLowerCase()];
  };

  const [labelHour, labelTimeSuffix] = transformRawString(label);
  const [filterHour, filterTimeSuffix] = transformRawString(filter);

  if (!filterHour) return true;

  if (filterTimeSuffix && !labelTimeSuffix.startsWith(filterTimeSuffix)) return false;

  if (filterHour.length < 3 && Number(filterHour) < 24) {
    return labelHour.slice(0, -2) === filterHour;
  }

  return labelHour.startsWith(filterHour);
};

const { block } = bem('hook-form-time-picker');

function AutocompleteTimePicker(props) {
  const { className, onChange: onChangeBubbleUp = () => {}, inlineLabel } = props;
  let { options, placeholder } = props;
  const intl = useIntl();
  options = options || getTimes(intl);
  placeholder = placeholder || messages.placeholder.timePicker;

  return (
    <Dropdown
      {...props}
      autocomplete
      options={options}
      optionsFilter={filterTime}
      placeholder={placeholder}
      className={block('mb-l', className)}>
      {({ hasError, value, onChange: onChangeLocal }) => {
        function onChange(selected) {
          onChangeLocal(selected);
          onChangeBubbleUp(selected);
        }

        return (
          <>
            <DropdownToggle placeholder={placeholder} hasError={hasError} label={inlineLabel}>
              {value}
            </DropdownToggle>
            <DropdownMenu>
              {data =>
                data.map(({ option, isHighlighted, ref }) => {
                  return (
                    <DropdownItem
                      key={option.match}
                      ref={ref}
                      isSelected={option.value === value}
                      isHighlighted={isHighlighted}
                      onClick={() => onChange(option.value)}>
                      {option.label}
                    </DropdownItem>
                  );
                })
              }
            </DropdownMenu>
          </>
        );
      }}
    </Dropdown>
  );
}

AutocompleteTimePicker.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      match: PropTypes.string,
    })
  ),
  placeholder: intlMessage,
  onChange: PropTypes.func,
  inlineLabel: intlMessage,
};

export default AutocompleteTimePicker;
